<script>
import { mapGetters } from 'vuex'
import Layout from '@layouts/main.vue'

export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  components: { Layout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      brand: 'contentful/getBrand',
    }),
    errorImage() {
      return this.brand?.errorImage?.fields?.file?.url
    },
  },
}
</script>

<template>
  <Layout screen="failure">
    <main :class="$style.page">
      <h3 :class="$style.title">
        404
        <template v-if="resource">
          {{ resource }}
        </template>
        Not Found
      </h3>
      <img v-if="errorImage" :class="$style.error" :src="errorImage" />
      <BaseLink :to="{ name: 'home' }">
        <BaseButton :class="$style.button">Try again</BaseButton>
      </BaseLink>
    </main>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.page {
  height: 100%;
  text-align: center;
  max-width: 280px;
  margin: auto;
  padding: 3rem 0;
}

.error {
  width: 70%;
  margin: 2rem auto;
}

.button {
  margin: 1rem 0;
}
</style>
